import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode, faFileAudio, faBookOpenReader, faAddressBook, faBookBookmark, faCertificate, faUserGroup, faSquare, faHistory, faTasks, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import './AboutThink5Whys.css';
import aboutthink5whysimage from '../../assets/pageimages/About.webp';

function AboutThink5WhysHome() {

return (
    <MainLayout>
        <div className="py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-16">
            <h2 className='text-lg mt-1 mx-8 text-white'>Think5Whys Platform & Modules</h2>
                <div className="flex justify-center mb-6">
                    <img src={aboutthink5whysimage} alt="About Think5Whys Platform Image" className="sm:w-1/4 lg:w-1/4 rounded-lg shadow-lg" />
                </div>
                <div className="px-4 grid grid-cols-2 sm:grid-cols-4 gap-6 mb-8 ">
                    <div className="bottom-buttons-box">
                        <CardLink to="/think5whys-module-card" icon={faFileAlt} text="Module Card" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-platform" icon={faBookOpenReader} text="Think5Whys Platform" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-learning" icon={faTasks} text="Learning" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-rca" icon={faSquare} text="5Whys Analysis" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-connect5" icon={faCertificate} text="Connect5" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-life-chronicle" icon={faFileAudio} text="LifeChronicle" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-communicapture" icon={faBookOpen} text="CommuniCapture" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-applause-hub" icon={faDownload} text="ApplauseHub" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-sigma-studio" icon={faAddressBook} text="SigmaStudio" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-sprint-central" icon={faStar} text="SprintCentral" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-jobs" icon={faHistory} text="Job&Works" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-spotsnap" icon={faHistory} text="SpotSnap" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-mydiary" icon={faHistory} text="MyDiary" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-myjournal" icon={faHistory} text="MyJournal" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-visigift" icon={faHistory} text="VisiGift" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-artflow" icon={faHistory} text="ArtFlow" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-assettagger" icon={faHistory} text="AssetTagger" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-besure" icon={faHistory} text="BeSure" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-bigdata" icon={faHistory} text="BigData" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-chaiwai" icon={faHistory} text="ChaiWai" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-attendance" icon={faHistory} text="Attendance" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-candlescope" icon={faHistory} text="CandleScope" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-donaqr" icon={faHistory} text="DonaQR" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-entrypass" icon={faHistory} text="EntryPass" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-eventflow" icon={faHistory} text="EventFlow" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-feedbackcompass" icon={faHistory} text="FeedbackCompass" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-digital-franchise" icon={faHistory} text="DigitalFranchise" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-integra" icon={faHistory} text="Integra" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-leadpulse" icon={faHistory} text="LeadPulse" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-life-resources" icon={faHistory} text="LifeResources" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-job-journal" icon={faHistory} text="JobJournal" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-journey-joy" icon={faHistory} text="JourneyJoy" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-manifesto" icon={faHistory} text="Manifesto" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-mealmarch" icon={faHistory} text="MealMarch" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-nothing-secret" icon={faHistory} text="NothingSecret" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-orderflow" icon={faHistory} text="OrderFlow" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-packetpulse" icon={faHistory} text="PacketPulse" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-paycheck" icon={faHistory} text="PayCheck" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-sacred-queue" icon={faHistory} text="SacredQ" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-scan-anytime" icon={faHistory} text="ScanAnytime" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-table-tales" icon={faHistory} text="TableTales" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-wait-well" icon={faHistory} text="WaitWell" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-walking-joy" icon={faHistory} text="WalkingJoy" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-welcome" icon={faHistory} text="Welcome" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-wheels-watch" icon={faHistory} text="WheelsWatch" />
                        </div>
                        <div className="bottom-buttons-box">
                        <CardLink to="/about-think5whys-whatsup" icon={faHistory} text="Whatsup" />
                        </div>
                </div>
        </div>
    </MainLayout>
    );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
    <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105 w-full">
      <Link to={to} className="flex flex-wrap items-center text-sm sm:text-lg text-gray-700 hover:text-gray-900">
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        {text}
      </Link>
    </div>
  );

export default AboutThink5WhysHome;
